import PaneMenuItem from './PaneMenuItem';

export default PaneMenuItem;
export { PaneMenuItem };
